// #3008 judge round 1 (B1), driver decision rule 3 -- db.js's
// bulkPutAncestorAware needs to know whether the scribe has typed an edit
// that has NOT yet been enqueued (the SAVE_DEBOUNCE_MS window between
// applySheet() and persist() actually firing, in useScoreSheet.js). An
// outbox op alone doesn't cover that window: nothing is queued yet, so a
// server-fresh row landing mid-debounce would otherwise read as "no
// divergence" and get its ancestor (and content) silently advanced out from
// under an edit the scribe hasn't saved.
//
// This is a small in-memory registry, not React state, on purpose: db.js
// (and sync.js) are framework-agnostic and have no hook to read state from,
// and this needs to be read synchronously inside an IndexedDB transaction
// loop. It never persists across a reload -- that's fine, a reload has no
// in-flight debounce timer to protect either.
//
// Keyed by the SAME entityKey format entityKeyOf() computes in db.js
// (`${rideId}::${judgeId}`, no `scoreSheet:` prefix) and the outbox opId's
// own entityKey half, so a lookup here always lines up with the row a
// server-sourced write is about to touch.
const unsavedEntityKeys = new Set();

export function markUnsavedEdit(entityKey) {
  if (entityKey) unsavedEntityKeys.add(entityKey);
}

export function clearUnsavedEdit(entityKey) {
  if (entityKey) unsavedEntityKeys.delete(entityKey);
}

export function hasUnsavedEdit(entityKey) {
  return entityKey != null && unsavedEntityKeys.has(entityKey);
}

// #3518: how many entities have an edit typed but not yet queued, so Clear The
// Machine can refuse to wipe over them and say how many.
export function countUnsavedEdits() {
  return unsavedEntityKeys.size;
}

// Test-only: reset between specs so one test's marked entity can't leak into
// another's assertions (this registry is module-level, not per-test-DB like
// _resetDbForTests()).
export function _resetUnsavedEditsForTests() {
  unsavedEntityKeys.clear();
}
